// extracted by mini-css-extract-plugin
module.exports = {"input-group":"InputGroup_input-group__Zq5FH"};